import { createContext, useContext } from 'react';
import type { VisualHistory } from '../scene/history';

/** Undo/redo history for scene and character edits of the open project. */
export const VisualHistoryContext = createContext<VisualHistory | null>(null);

export function useVisualHistory(): VisualHistory {
  const history = useContext(VisualHistoryContext);
  if (!history) throw new Error('useVisualHistory must be used inside an open project.');
  return history;
}
